import i18n from '@/plugins/i18n'
import { FORUM_NAVBAR_LAYOUT, PRIVATE_LAYOUT } from '@/constants/layouts'
import { PATIENT_ROLE, PROFESSIONAL_ROLE, CENTER_ROLE } from '@/constants/roles'
import routeHelpers from '@/router/routeHelpers'
import store from '@/store'
import { normalize } from '@/helpers/i18n.helpers'

function scrollTop(to, from, next) {
    window.scrollTo(0, 0)
    next()
  }

let routes = [
	{
			path: ':surveyId',
			name: 'do-survey',
			component: () => import('@/components/views/surveys/SurveyTest'),
			meta: {
					title: {
						text () {
							return `${store.state.survey.currentSurvey ? `${normalize(store.state.survey.currentSurvey)}` : `${i18n.t('survey')}`}`
						}
				},
				i18n: 'public/views/survey'
			}
	},
]

export default routeHelpers.completeRoutesMeta(routes, [PATIENT_ROLE, PROFESSIONAL_ROLE, CENTER_ROLE], PRIVATE_LAYOUT)


// WEBPACK FOOTER //
// ./src/router/routes/webapp/survey.routes.js